import React from 'react';
import TextField from '@mui/material/TextField';
import type { TextFieldProps } from '@mui/material';

type TextAreaProps = TextFieldProps & {
  validateIsNotEmpty?: boolean | undefined;
  handleChange: (value: unknown) => void;
  handleBlur?: (value: unknown) => void;
};

function TextArea(props: TextAreaProps) {
  const { validateIsNotEmpty = false, rows, handleChange, handleBlur, ...rest } = props;

  return (
    <TextField
      multiline
      variant='standard'
      required={validateIsNotEmpty || false}
      fullWidth
      onChange={(event) => handleChange(event.target.value)}
      inputProps={{
        onBlur: (event) => {
          if (handleBlur !== null && handleBlur !== undefined) {
            handleBlur(event.target.value);
          }
        },
      }}
      rows={rows != null ? rows : 5}
      {...rest}
    ></TextField>
  );
}

export type { TextAreaProps };

export default TextArea;
